module.exports = __webpack_public_path__ + "img/256.4fb0020c.jpg";